import ShoppingCartButton from './shopping-cart-button';

export {
  ShoppingCartButton
};



// WEBPACK FOOTER //
// ./components/partials/shopping-cart-button/index.js